
import { useEffect, useState, useRef } from "react";
import { Button, Col, Row } from "react-bootstrap";
import { NoData } from "../common/NoData";
import { updateTakafulPremium } from "../../features/product";
import { useDispatch, useSelector } from "react-redux";
import "../customCheckbox.css";
import { CompanyDetails } from "../CompanyDetails";
import { Loader } from "../common/loader";
import { useTranslation } from "react-i18next";
import "../../components/InsuranceCard.css";
import { ReactComponent as OmrSymbol } from "../../assets/SVG/omr_symbol.svg";

export const TakafulCompanyCard = ({ data, buyNowHandler }) => {
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();
  const currentLanguage = i18n.language;
  const [cardData, setCardData] = useState();
  const [show, setShow] = useState(false);
  const hasInitializedOptionalPremium = useRef(false);
  const [showAllCovers, setShowAllCovers] = useState(false);
  const [isCovers, setShowCover] = useState(false);

  let optionalCoverkey = {};

  const { updateTakafulPremiumLoader } = useSelector((state) => state.product);

  const isTravel = cardData?.product_id === 15 && cardData?.sub_product_id === 20;

  const formatKey = (text) => {
    if (!text) return "";
    return text
      .toLowerCase()
      .trim()
      .replace(/\s+/g, "_")       // spaces → _
      .replace(/[^\w_]/g, "");    // remove special chars
  };

  useEffect(() => {
    setCardData((prevData) => {
      return JSON.stringify(prevData) !== JSON.stringify(data)
        ? data
        : prevData;
    });
  }, [data]);

  const handleShow = () => setShow(true);

  const handleOptionalCoverChange = (e, cover_item, coverIndex) => {
    const updatedCardData = JSON.parse(JSON.stringify(cardData));
    updatedCardData.optional_covers[coverIndex].isSelected = e.target.checked;

    if (cover_item?.cover_description === "Claim Nil Access") {
      updatedCardData.nil_excess_loading = updatedCardData.optional_covers[0]
        .isSelected
        ? "Yes"
        : "No";
    } else if (cover_item?.cover_description === "Sports Activities") {
      updatedCardData.sport_activity_loading = updatedCardData
        .optional_covers[1].isSelected
        ? "Yes"
        : "No";
    } else if (cover_item?.cover_description === "TopUp benefits") {
      updatedCardData.top_up_benefits_loading = updatedCardData
        .optional_covers[2].isSelected
        ? "Yes"
        : "No";
    }

    setCardData(updatedCardData);

    dispatch(
      updateTakafulPremium({
        ...updatedCardData,
        ...updatedCardData.extracted_data,
        ...optionalCoverkey,
        nil_excess_loading: updatedCardData.nil_excess_loading,
        sport_activity_loading: updatedCardData.sport_activity_loading,
        top_up_benefits_loading: updatedCardData.top_up_benefits_loading,
      })
    ).then((res) => {
      const updatedResponseData = {
        ...updatedCardData,
        ...res.payload,
        optional_covers: updatedCardData.optional_covers,
        nil_excess_loading: updatedCardData.nil_excess_loading,
        sport_activity_loading: updatedCardData.sport_activity_loading,
        top_up_benefits_loading: updatedCardData.top_up_benefits_loading,
        base_price:
          res.payload?.extracted_data?.tax_details?.tax_parts[0]?.amount?.toFixed(
            3
          ) ||
          res.payload?.base_price ||
          0,
        premium_value:
          res.payload?.extracted_data?.tax_details?.tax_parts[0]?.amount &&
            res.payload?.extracted_data?.tax_details?.tax_parts[0]?.value
            ? (
              (parseFloat(
                res.payload?.extracted_data?.tax_details?.tax_parts[0]?.amount
              ) || 0) +
              (parseFloat(
                res.payload?.extracted_data?.tax_details?.tax_parts[0]?.value
              ) || 0)
            ).toFixed(3)
            : res.payload?.premium_value || 0,
        area_of_coverage: updatedCardData?.area_of_coverage,
      };
      setCardData(updatedResponseData);
    });
  };

  return (
    <div className="card insurance-card h-100">
      {updateTakafulPremiumLoader ? (
        <Loader type="logo-gif" />
      ) : (
        <>
          {/* Header Section */}
          <div className="card-header-custom">
            <a className="details-link" onClick={() => {
              handleShow()
              setShowCover(false)

            }}>
              ⓘ {t("view_details")}
            </a>
            <div className="flex-fill">
              <div className="insurance-row just">
                <div className="insurance-logo mt-6">
                  <img
                    src={data?.company_image}
                    alt={data?.company_name}
                  />
                </div>
                <div className="insurance-content mt-2">
                  <h4 className="company-title">{t(data.company_name.toLowerCase()
                    .trim()
                    .replace(/\s+/g, "_")        // replace spaces with _
                    .replace(/[^\w_]/g, ""))}</h4>
                  <div className="badge-row gap-2">

                    <div className="badge-column">
                      <span className="badge-grey">{t('instantInsurance')}</span>
                      <span className="badge-grey">{t('branches')}: 2</span>

                    </div>

                    <div className="badge-column">
                      <span className="badge-grey">{t('endorsement24to48')}</span>
                      {/* {!isTravel && (
                        <span className="badge-dark-yellow">{t('photosNotRequired')}</span>
                      )}                      */}
                      <span className="badge-dark-yellow">  {t("planName")} - {cardData?.plan_name}</span>

                    </div>
                  </div>
                </div>
              </div>
            </div>


            {/* Area/Vehicle Value */}
            {/* {data?.product_id === 15 && data?.sub_product_id === 20 ? (
          <div className="badge-light-custom w-100 text-center">
            {t("graphical_area_label")}: {currentLanguage === "ar"
              ? data?.area_of_coverage?.display_value_ar || "NA"
              : data?.area_of_coverage?.display_value_en || "NA"}
          </div>
        ) : (
          <div className="badge-light-custom w-100 text-center">
            {t("vehicle-value")}: {data?.extracted_data?.valuations ||
              data?.extracted_data?.vehicle_valuation ||
              "NA"}
          </div>
        )} */}
          </div>

          <CompanyDetails
            show={show}
            companyData={cardData}
            isCovers={isCovers}
            handleClose={() => setShow(false)}
          />

          {/* Included Covers Section */}
          <div className="p-3 h-[100px]">
            <h6 className="section-title">{t("includedcovers")}</h6>
            <Row className="g-1">
              {cardData?.included_covers && cardData?.included_covers.length ? (
                <>
                  {(showAllCovers ? cardData.included_covers : cardData.included_covers.slice(0, 4)).map((cover_item, coverIndex) => (
                    <Col xs={6} key={`cover_included_${coverIndex}`}>
                      <div className="cover-item">
                        <span className="checkmark-icon">✓</span>
                        <span>
                          {cover_item?.cover_description}
                          {cover_item?.cover_coverage && cover_item?.cover_coverage !== '0'
                            ? ` - ${cover_item?.cover_coverage} ${cardData?.product_id === 1 &&
                              (cardData?.sub_product_id === 1 || cardData?.sub_product_id === 21)
                              ? "OMR"
                              : ""
                            }`
                            : ""}
                        </span>
                      </div>
                    </Col>
                  ))}
                  {data.included_covers.length > 4 && (
                    <div className="p-0 m-0">
                      <button
                        className="btn btn-link p-0 m-0 text-decoration-none"
                        style={{ color: '#ff9800', fontSize: '0.9rem' }}
                        // onClick={() => setShowAllCovers(!showAllCovers)}
                        onClick={() => {
                          setShow(true)
                          setShowCover(true)
                        }}
                      >
                        {showAllCovers ? "See less" : t('see_more')}
                      </button>
                    </div>
                  )}
                </>
              ) : (
                <Col xs={12}>
                  <NoData msg={t("noCoverMsg")} />
                </Col>
              )}
            </Row>
          </div>


          {cardData?.optional_covers?.length > 0 &&
            !(cardData?.product_id === 1 && cardData?.sub_product_id === 21) && (
              <div className="card-body pt-0">
                <h6 className="section-title">{t("optionalcovers")}</h6>
                <Row className="g-0">
                  {cardData.optional_covers.map((cover_item, coverIndex) => (
                    <Col xs={6} key={`cover_optional_${coverIndex}`}>
                      <div className="optional-item">
                        <input
                          id={`cover_tk_cb_${coverIndex}`}
                          type="checkbox"
                          className="checkbox-custom"
                          checked={cover_item?.isSelected}
                          onChange={(e) =>
                            handleOptionalCoverChange(e, cover_item, coverIndex)
                          }
                        />
                        <label
                          htmlFor={`cover_tk_cb_${coverIndex}`}
                          style={{ cursor: 'pointer', margin: 0 }}
                        >
                          {t(formatKey(cover_item?.cover_description))}
                        </label>
                      </div>
                    </Col>
                  ))}
                </Row>
              </div>
            )}


          {/* Pricing Footer */}
          <div className="pricing-section mt-auto">
            <div className="price-row">

              {/* LEFT : Base Price */}
              <div className="base-price-section">
                {(() => {
                  const isGraphical =
                    data?.product_id === 15 && data?.sub_product_id === 20;

                  const value = isGraphical
                    ? currentLanguage === "ar"
                      ? data?.area_of_coverage?.display_value_ar
                      : data?.area_of_coverage?.display_value_en
                    : data?.extracted_data?.vehicle_valuation;

                  if (!value || value === "N/A" || value === "NA") return null;

                  return (
                    <h5 className="graphic-text">
                      {isGraphical
                        ? `${t("graphical_area_label")} : ${value}`
                        : `${t("vehicle-value")} : ${value}`}
                    </h5>
                  );
                })()}
                <div className="base-price-label">{t("basePrice")}</div>

                <div className="base-price-inline">
                  <span className="currency-icon" style={{ marginTop: "4px" }}>
                    {data?.premium_currency === "OMR" ? (
                      <OmrSymbol width={24} height={24} />
                    ) : (
                      data?.premium_currency
                    )}
                  </span>
                  <div>
                    <span className="base-price-value">{data?.base_price}</span>
                    <span className="tax-inline">+VAT Exlc</span>
                  </div>
                </div>
              </div>

              {/* RIGHT : Total + Button */}
              <div className="total-price-section">
                <div className="total-price-label">{t("totalPayment")}</div>

                <div className="total-price-value">
                  <span className="currency-icon">
                    {data?.premium_currency === "OMR" ? (
                      <OmrSymbol width={24} height={24} />
                    ) : (
                      data?.premium_currency
                    )}
                  </span>
                  {data?.premium_value}
                </div>

                <button
                  className="btn-buy-now"
                  onClick={() => buyNowHandler(data)}
                >
                  {t("buyNow")}
                </button>
              </div>

            </div>

            {/* <div className="vat-note">
          ({t("vat_include")})
        </div> */}
          </div>
        </>
      )}
    </div>
  );
};

